import type { UserResponseData } from '@kimuno/api-sdk';

interface AppContext {
	resetPasswordEmail?: string;
	userId?: string;
	user?: UserResponseData;
}

const data: AppContext = {
	resetPasswordEmail: undefined,
	user: undefined,
	userId: undefined,
};

const service = {
	getResetPasswordEmail: () => data.resetPasswordEmail,
	// biome-ignore lint/suspicious/noAssignInExpressions: pre-existing assignment-in-expression; extracting it risks changing evaluation order
	setResetPasswordEmail: (email: string) => (data.resetPasswordEmail = email),
};

export default service;
